import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import type { Adjustment, RouteDef } from '@ztechapps/common.contract'
import { LocalDate } from '@ztechapps/webui.date'
import { Link } from 'react-router-dom'
import { ActivityListField } from '@ztechapps/webui.data-tools'
import React from 'react'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { AdjustmentStatusBadge } from '../StatusBadge'
import { Tags } from '@ztechapps/webui.input'

const CodeColumn = (props: BodyRowConfig<Adjustment>) => {
  const adjustmentItemRoute = useInject<RouteDef>(WebuiIocKey.routes.adjustmentItem)

  const { code, _id } = props
  return (
    <Link to={adjustmentItemRoute.altPath({ _id })}>
      <b>{code}</b>
    </Link>
  )
}

const StatusColumn = (props: BodyRowConfig<Adjustment>) => {
  const { status } = props
  return <AdjustmentStatusBadge status={status} />
}

export const DataListRow = (props: BodyRowConfig<Adjustment>) => {
  const { createdAt, completionDate, tags, remarks, remarksActivity } = props

  return (
    <>
      {props._renderDataBodyCell({
        status: <StatusColumn {...props} />,
        code: <CodeColumn {...props} />,
        tags: <Tags dataArray={tags} />,
        remarks: <ActivityListField remarks={remarks} remarksActivity={remarksActivity} />,
        createdAt: <LocalDate value={createdAt} />,
        completionDate: <LocalDate value={completionDate} />,
      })}
    </>
  )
}
